export default async function refresh() {
  const responseData = await this.api({
    url: "users/refresh/",
  });

  if (responseData.status === 200) {
    this.$store.commit("userData", responseData.body);
  }
}
